import React from "react";

const iconStarEmpty = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style={{ width: 30 }}
      xmlSpace="preserve"
    >
      <path
        stroke="#FFD87F"
        strokeWidth="10"
        d="M383.9,452.6l-127.7-67.1l-127.7,67.1L153,310.4L49.7,209.7L192.4,189l63.8-129.3L320.1,189l142.7,20.7
L359.5,310.4L383.9,452.6z M256.2,384.3l0.2,0.1l126.1,66.3l-24.1-140.7l102.2-99.6l-141.2-20.5l-0.1-0.2L256.2,61.9l-63.2,128
l-0.3,0l-141,20.5L154,310.1l0,0.3l-24.1,140.4L256.2,384.3z"
      />
    </svg>
  );
};

const iconStarFull = () => {
  return (
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style={{ width: 30 }}
      xmlSpace="preserve"
    >
      <polygon
        fill="#FFD87F"
        points="256.2,60.8 319.7,189.4 461.7,210.1 359,310.2 383.2,451.6 256.2,384.9 129.2,451.6 153.5,310.2 
50.8,210.1 192.7,189.4 "
      />
    </svg>
  );
};

export default {
  iconStarEmpty,
  iconStarFull
};



// WEBPACK FOOTER //
// ./src/components/StarRating.js